// extracted by mini-css-extract-plugin
export default {"wrapper":"TypeFilter_wrapper__FW-qy","optionsWrapper":"TypeFilter_optionsWrapper__IpGQl","loading":"TypeFilter_loading__HkNCN"};